class QuantityStepper extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-buy-quantity-input]');
    this.querySelector('[data-quantity-decrease]').addEventListener('click', () => this.step(-1));
    this.querySelector('[data-quantity-increase]').addEventListener('click', () => this.step(1));
  }

  step(delta) {
    const min = Number(this.input.min) || 1;
    const value = Math.max(min, (parseInt(this.input.value, 10) || min) + delta);
    this.input.value = value;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('quantity-stepper', QuantityStepper);
